import type { VoiceProvider } from "../types";
import { StubVoiceProvider } from "./stub/StubVoiceProvider";

export type VoiceProviderId = "stub";

const PROVIDERS: Record<VoiceProviderId, VoiceProvider> = {
  stub: StubVoiceProvider,
};

/** Mirrors `services/ai/providers/index.ts` — the seam a real local engine
 * registers into. Always returns the stub today. */
export function getActiveVoiceProvider(): VoiceProvider {
  return PROVIDERS.stub;
}
